import api from "../lib/api";

export const submitCustomDesignRequest = async (payload) => {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") form.append(key, value);
  });
  const { data } = await api.post("/custom-design", form);
  return data;
};
